import { DownloadOutlined, EyeOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Space, Table, Tag, Typography } from 'antd';
import Column from 'antd/es/table/Column';
import { useState } from "react";
import { Link } from 'react-router-dom';
import ModalTextForm from "../../components/modal/ModalTextForm";
import { urlAdmin } from "../../constants";
import { Links } from '../../helpers/Links';
import { dateCommon } from "../../helpers/common";
import { ChiTietHopDongResponse } from "../../models/hopdong/HopDong";
const { TextArea } = Input;
const { Text } = Typography;

const XemHopDongBox = ({hopDongInfo, show, onClose }: { hopDongInfo: ChiTietHopDongResponse, show: boolean, onClose: () => void}) => {
    const renderTepHopDongDienTu = () => {
        const urlTep = urlAdmin + (hopDongInfo.fileKySo || '').replace(/\\/g, '/');
        return (
            <Space size={6} wrap>
                <FilePdfOutlined style={{ color: '#d4380d' }} />
                <Text>{hopDongInfo.tenFileKySo}</Text>
                <Button type="primary"
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => window.open(urlTep, '_blank') }>
                    Xem file
                </Button>
                <a href={urlTep} download={hopDongInfo.tenFileKySo}>
                    <Button className="hrm-btn hrm-btn-success" size="small" icon={<DownloadOutlined />}>Tải về</Button>
                </a>
                <Link
                    className="hrm-btn hrm-btn-sm hrm-btn-success" target="_blank" rel="noopener noreferrer" 
                    icon={<EyeOutlined />}
                    title="Xem chi tiết hợp đồng điện tử"
                    to={`${Links.HopDong.ChiTietHopDongDienTu}?id=${hopDongInfo?.idHopDongDienTu}`}
                >
                    Xem chi tiết
                </Link>
            </Space>
        );
    };

    return (
        <ModalTextForm
            show={show} hideFooter
            size="xl"
            title='Thông tin hợp đồng/quyết định bổ nhiệm'
            handleClose={() => {
                onClose();
            }}>
            <Row>
                <Col span="24" className="form-group row">
                    <Col span="8" className="form-group">
                        <div>Trạng thái</div>
                        <label>                                
                            <Tag color={hopDongInfo?.trangThai ? "green" : "red"}>{hopDongInfo?.trangThai ? "Hiệu lực" : "Hết hiệu lực"}</Tag>
                        </label>
                    </Col>
                    <Col span="8" className="form-group">
                        <div>Số hợp đồng/quyết định bổ nhiệm</div>
                        <label>                               
                             {hopDongInfo?.soHopDong}
                        </label>
                    </Col>
                    <Col span="8" className="form-group">
                        <div>Loại hợp đồng/quyết định bổ nhiệm</div>
                        <label>{hopDongInfo?.loaiHopDong}</label>
                    </Col>
                </Col>
                <Col span="24" className="form-group row">
                    <Col span="8" className="form-group">
                        <div>Ngày ký hợp đồng/quyết định bổ nhiệm</div>
                        <label>{dateCommon.formatDate(hopDongInfo?.ngayKy)}</label>
                    </Col>
                    <Col span="8" className="form-group">
                        <div>Từ ngày</div>
                        <label>{dateCommon.formatDate(hopDongInfo?.ngayBatDau)}</label>
                    </Col>
                    <Col span="8" className="form-group">
                        <div>Đến ngày</div>
                        <label>{dateCommon.formatDate(hopDongInfo?.ngayKetThuc)}</label>
                    </Col>
                </Col>
                <Col span="24" className="form-group row">
                    <Col span="8" className="form-group">
                        <div>Người ký</div>
                        <label>{hopDongInfo?.tenNguoiKy}</label>
                    </Col>
                    <Col span="8" className="form-group">
                        <div>Nơi ký</div>
                        <label>{hopDongInfo?.noiKy}</label>
                    </Col>
                    <Col span="8" className="form-group">
                        <div>Đóng BHXH</div>
                        <label><Tag color={hopDongInfo?.isDongBHXH ? "green" : "red"}>{hopDongInfo?.isDongBHXH ? "Đóng" : "Không đóng"}</Tag></label>
                    </Col>
                </Col>
                {
                    hopDongInfo?.idHopDongDienTu > 0 &&
                    <Col span="24" className="form-group row">
                        <Col span="24" className="form-group">
                            <div>File hợp đồng điện tử</div>
                            {renderTepHopDongDienTu()}
                        </Col>
                    </Col>
                }
                <Col span="24" className="form-group row">
                    <Col span="24" className="form-group">
                        <div>Hợp đồng/Quyết định bổ nhiệm đính kèm</div>
                        <Table
                            locale={{ emptyText: "Không có dữ liệu" }}
                            pagination={false} size='small'
                            dataSource={(hopDongInfo?.dsTaiLieu || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                        >
                            <Column
                                title="STT"
                                key="STT"
                                align="center"
                                render={(value, record, index) =>
                                (
                                    <>
                                        {index + 1}
                                    </>
                                )
                                }
                            />
                            <Column title="Tên tài liệu" key="tenTep" render={(value, record, index) => (
                                <p>{value?.tenTep?.replace(/^.*[\\/]/, '')}</p>
                            )} />
                            <Column title="Xem" key="Xem"
                                render={(value, record, index) =>
                                (
                                    <>
                                        <Button className="hrm-btn hrm-btn-sm hrm-btn-success" title="Xem" onClick={() => {
                                            window.open(urlAdmin + value?.duongDan?.replace(/\\/g, "/"), '_blank')
                                            //window.open(value?.duongDan?.replace("View\\public", "").replace(/\\/g, "/"), '_blank')
                                        }}><i className="fa fa-eye mr-2" />Xem</Button>
                                    </>
                                )
                                }
                            />
                            <Column title="Tải xuống" key="Xem"
                                render={(value, record, index) =>
                                (
                                    <>
                                        <a href={urlAdmin + value?.duongDan?.replace(/\\/g, "/")} download>
                                            <Button className="hrm-btn hrm-btn-sm hrm-btn-success" title="Tải xuống">
                                                <i className="fa fa-download mr-2" />Tải xuống
                                            </Button>
                                        </a>
                                    </>
                                    //<>
                                    //    <Link to={value?.duongDan?.replace("View\\public", "").replace(/\\/g, "/")} target="_blank" download>
                                    //        <Button className="hrm-btn hrm-btn-sm btn-success" title="Tải xuống">
                                    //            <i className="fa fa-download mr-2" />Tải xuống
                                    //        </Button>
                                    //    </Link>
                                    //</>
                                )
                                }
                            />
                        </Table>
                    </Col>
                </Col>
            </Row>
        </ModalTextForm>
    );
};

export default XemHopDongBox;